import React, { useRef, lazy, useEffect, Suspense } from 'react';
import * as R from 'ramda';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { getLocale } from '../selectors/router';

const ReCAPTCHA = lazy(() => import('react-google-recaptcha'));
const endPoint = '/api/captcha/verify';

const Captcha = ({ callback = R.identity }) => {
  const captchaRef = useRef();
  const locale = useSelector(getLocale);

  useEffect(() => {
    import('react-google-recaptcha');
  }, []);

  const handleSubmit = async (token) => {
    const {
      data: { isSuccess },
    } = await axios.post(endPoint, { token });
    callback({ isSuccess });
  };

  return (
    <Suspense>
      <ReCAPTCHA
        ref={captchaRef}
        theme={'light'}
        sitekey={window.CONFIG.captchaSiteKey}
        onChange={handleSubmit}
        hl={locale}
      />
    </Suspense>
  );
};

export default Captcha;
